import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { dataPath } from '../services/dataService';

// Called from bootstrap() in index.js after dataService.init() resolves,
// so supportedLngs can be loaded from the manifest rather than hardcoded.
export function initI18n(supportedLngs = ['en']) {
  return i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: dataPath('languageLocale').replace('{code}', '{{lng}}'),
      },
      fallbackLng: 'en',
      supportedLngs,
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
      },
    });
}

export default i18n;
